import { render, staticRenderFns } from "./UpdateStatusModal.vue?vue&type=template&id=f3172aa6"
import script from "./UpdateStatusModal.vue?vue&type=script&lang=js"
export * from "./UpdateStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports